export default "__VITE_ASSET__BY39dhwv__"